import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M13,2C6.7,2,1.5,6.3,1.5,11.5c0,2.8,1.4,5.4,4,7.2c-0.6,1.1-1.5,2.1-2.6,2.7l-2.6,1.4l3,0.2c0.3,0,0.6,0,0.9,0 c1.3,0,2.6-0.2,3.8-0.5c1.3-0.4,2.6-0.9,3.7-1.6c0.4,0,0.9,0.1,1.3,0.1c6.3,0,11.5-4.3,11.5-9.5C24.5,6.3,19.3,2,13,2z" />
    </g>
  </svg>
);
